"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "chunkPromise", {
    enumerable: true,
    get: function() {
        return chunkPromise;
    }
});
async function chunkPromise(promises, limit = 5) {
    for(let i = 0; i < promises.length; i += limit){
        await Promise.all(promises.slice(i, i + limit).map((p)=>typeof p === "function" ? p() : p));
    }
}
